import React, { useState, useEffect, Component } from "react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import "../Profile/TeacherProfile.css";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
// import PopUp from "../../Components/PopUpForm/ShareProfile-PopUp";
import CanDeliverForm from "./CanDeliverFormCollege";
import { getCanDelivers } from "./profile.utils";
import "./Campus.css";
import { createImageFromInitials } from "../../Helper";
import { getClassCategories } from "../../Helper";
import RoomOrProgramPopup from "./RoomOrProgramPopup";
import LocalParkingIcon from '@mui/icons-material/LocalParking';
const _ = require('lodash')

const CollegeProfile = (props) => {
  const { campuses, personnels, isViewAsCollege, institution, isAbleToEdit, 
    qualifications, selectedItem, selectedCanDelivers, selectedByQualification, user,
    roomsAndProgramsList, selectedRoomsPrograms, selectedRoomsProgramsQual
    } = props;
  const [isClassPopup, toggleClassPopup] = useState(false);
  const [isRoomOrProgram, setIsRoomOrProgram] = useState(false);
  const toggleClass = () => {
    toggleClassPopup(true)
  }

  const toggleRoomOrProgramPopup = () => {
    setIsRoomOrProgram(true)
  }
  // const canDelivers = createcanDelivers(user)

  const cd_ref = React.createRef();

  let addMoreCanDeliver;
  let addMoreRoomsOrPrograms;
  let updateCampus;
  let addMoreCampus;
  let inCampus;
  //constructe the canDelivers to present in the can delivers.
  // const canDelivers = getCanDelivers(institution);
  // const all_categories = getClassCategories();
  // const cd_categories = Object.keys(canDelivers).filter((category) => canDelivers[category].length);
  const isCanDeliver = !!Object.keys(selectedItem)?.length;

  // if there is already a campus/campuses, then the footer will be "update campus"
  updateCampus = (
    <Link title={institution?.is_childcare_centre ? "Centres" : "Campuses"} to="/Campus">
      <Icon
        name="pencil"
        circular
        inverted
        color="teal"
        className="qualification-container-update-icon"
      >
        {" "}
      </Icon>
      {"  "}{institution?.is_childcare_centre ? "Update Centres" : "Update Campuses"}
    </Link>
  )

  // if there is no campus, then the footer will be "Add New"
  addMoreCampus = (
    <Link title={institution?.is_childcare_centre ? "Centres" : "Campuses"} to="/Campus">
      <Icon
        name="add"
        circular
        inverted
        color="teal"
        className="qualification-container-update-icon"
      >
        {" "}
      </Icon>
      {"  "}Add New
    </Link>

  )

  addMoreCanDeliver = (
    <span onClick={toggleClass}>
      <Icon
        name="add"
        circular
        inverted
        color="teal"
        className="qualification-container-update-icon"
      >
        {" "}
      </Icon>
      {"  "}Add New
    </span>
  )

  addMoreRoomsOrPrograms = (
    <span onClick={toggleRoomOrProgramPopup}>
      <Icon
        name="add"
        circular
        inverted
        color="teal"
        className="qualification-container-update-icon"
      >
        {" "}
      </Icon>
      {"  "}Add New
    </span>
  )

  useEffect(() => {
    var focus_ref = null
    if (window.location.hash == '#updateCourseDeliver') {
      focus_ref = cd_ref
    }
    if (focus_ref) {
      console.log('scroll')
      focus_ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [])

  return (
    <div className="teacher-profile-wrapper">
      {isClassPopup && (
        <CanDeliverForm
          institution={institution}
          showPopup={toggleClassPopup}
          qualifications={qualifications}
          selectedData={selectedCanDelivers}
          selectedByQualificationObj={selectedByQualification}
        />
      )}
      {isRoomOrProgram && (
        <RoomOrProgramPopup
          institution={institution}
          showPopup={setIsRoomOrProgram}
          qualifications={roomsAndProgramsList}
          selectedData={selectedRoomsPrograms}
          // selectedByQualificationObj={roomsAndProgramsList}
        />
      )}
      {/* the campuses box, the data is now for the testing account */}
      <div className='qualification-canDeliver-wrapper'>
        <div>
          {campuses && personnels && campuses.length > 0
            ?
            (<ProfileBox
              header={institution?.is_childcare_centre ? "CENTRES" : "CAMPUSES"}
              footer={isViewAsCollege && isAbleToEdit ? updateCampus : null}>
              <ul className="container p-2">
                {campuses
                  .map((q, index, array) => {
                    return (
                      <li key={q._id}>
                        <p className="mb-2 profile-box-title">
                          {q.suburb ? (q.suburb + " | ") : null}
                          {q.state ? q.state + " | " : null}
                          {q.address_line1 + (q.address_line2 ? ', ' + q.address_line2 : '')}
                        </p>
                        <p hidden>{inCampus = q._id}</p>

                        <ul>
                          {institution?.is_childcare_centre && (
                            <li key={q._id}>
                              <>
                                <LocalParkingIcon/>
                                <p className="d-inline">{'  '}
                                  {q?.car_parking} 
                                  {
                                    q?.car_parking_location?.address
                                      ? " - " + (q?.car_parking_location?.detail ? q?.car_parking_location?.detail + " " : "") + q?.car_parking_location?.address 
                                      : ""
                                  }
                                </p>
                              </>
                            </li>
                          )
                          }
                          {personnels.map((q, index, array) => {
                            return (
                              <li key={q._id}>
                                {q.campuses && q.campuses.includes(inCampus) ? (
                                  <>
                                    {q.photo ?
                                      <img className='personnel-avatar d-inline mr-1' src={q.photo} /> :
                                      <img className='personnel-avatar d-inline mr-1 rounded-circle' src={createImageFromInitials(100, q.personnel_first_name + " " + q.personnel_last_name, '#bdbdbd')} />}
                                    <p className="d-inline">{'  '}
                                      {q.personnel_first_name} {q.personnel_last_name} | {q.personnel_role}
                                    </p>
                                  </>) :
                                  (null)
                                }
                              </li>
                            )
                          })}
                        </ul>

                        {index !== (array.length - 1) &&
                          <div className="col-12">
                            <hr className="qualification-line-1 my-3"></hr>
                          </div>
                        }
                      </li>
                    )
                  })
                }
              </ul>
            </ProfileBox>) : (
              <ProfileBox
                header={institution?.is_childcare_centre ? "CENTRES" : "CAMPUSES"}
                footer={isViewAsCollege && isAbleToEdit ? addMoreCampus : null}>
              </ProfileBox>
            )}
        </div>

        {/* the course delivered box */}
        <div>
          <span ref={cd_ref}></span>
          <ProfileBox
            header={institution?.is_childcare_centre ? "ROOMS & PROGRAMS" : "COURSES DELIVERED"}
            footer={isViewAsCollege && isAbleToEdit && (!institution?.is_childcare_centre ? addMoreCanDeliver : addMoreRoomsOrPrograms)}>
            {isCanDeliver && !institution?.is_childcare_centre ?
              <ul className="container p-0">
                {(
                  <li className="row">
                    {Object.keys(selectedItem)
                      ?.map((category, index, arr) => {
                        return <div className="col-12">
                          <p className="mb-2 profile-box-title">
                            {category?.split("_keyID:")?.[0]}
                          </p>
                          <p>
                            {selectedItem[category]
                              .map((cl) => cl.split("_id:")?.[0])
                              .join(" | ")}
                          </p>
                          {index !== (arr?.length - 1) && <hr className="my-3 qualification-line-1"></hr>}
                        </div>;
                      })}
                  </li>
                )}
              </ul>
              : null
            }
            {
              institution?.is_childcare_centre && selectedRoomsProgramsQual?.length > 0 && (
                <ul className="container p-0">
                  {(
                    <li className="row">
                      {
                        selectedRoomsProgramsQual.map(qualification => {
                          return <div className="col-12">
                            <p className="mb-2 profile-box-title">
                              {qualification.title}
                            </p>
                          </div>
                        })
                      }
                    </li>
                  )}
                </ul>
              )
            }
          </ProfileBox>
        </div>
      </div>


      {
        !institution?.is_childcare_centre && (
          <div>
            <ProfileBox header='Compliments - Coming Soon'>
            </ProfileBox>
          </div>
        )
      }
    </div>
  );
}

export default CollegeProfile;
